import { CheckIcon } from '..';
import { DesContent } from '../DescriptionModal/Description.styled';
import { FirmAvProps } from './secondmentInterestTypes.props';
import { Div, TextLabel } from './secondmentInterestTypes.styled';

const SecondmentInterestTypes = ({ interestData }: FirmAvProps) => {

    return (
        <Div className="container">
            {interestData && interestData?.comOfferingSecondmentInterestTypes?.length ? (
                <DesContent className="description">
                    {interestData.comOfferingSecondmentInterestTypes.map((item, index) => {
                        return (
                            <Div key={index} className="availble-item">
                                <Div className="icon">
                                    <CheckIcon />
                                </Div>
                                <TextLabel>{item!.fksecondmentInterestType?.secondmentInterestType}</TextLabel>
                            </Div>
                        );
                    })}
                </DesContent>
            ) : null}
        </Div>
    );
};

export default SecondmentInterestTypes;
